import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  icon: {
    marginRight: theme.spacing(1),
  },

  summaryCard: {
    borderRadius: 12,
    padding: theme.spacing(2.5),
    height: '100%',
  },

  summaryTitle: {
    color: '#6B778C',
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: 11,
  },

  summaryValueRow: {
    display: 'flex',
    alignItems: 'baseline',
    marginTop: theme.spacing(1.5),
    gap: theme.spacing(0.8),
  },

  summaryValue: {
    fontWeight: 700,
    lineHeight: 1,
  },

  summaryTotal: {
    color: '#6B778C',
    lineHeight: 1,
  },

  summaryLabel: {
    color: '#6B778C',
    fontWeight: 500,
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },

  summaryIcon: {
    width: 38,
    height: 38,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  progressTrack: {
    width: '100%',
    height: 8,
    borderRadius: 999,
    backgroundColor: '#E5EAF0',
    overflow: 'hidden',
  },

  progressBar: {
    height: '100%',
    borderRadius: 999,
    transition: 'width 0.3s ease',
  },

  filterActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },

  progressWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 120,
  },

  progressText: {
    minWidth: 42,
    fontWeight: 600,
    color: '#2F3B52',
    fontSize: 12,
  },

  statusChip: {
    fontWeight: 600,
  },

  actionButton: {
    textTransform: 'none',
    minWidth: 110,
  },
}));
